import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HeroCarousel',
})(({ aspectRatio, breakpoints }) => ({
  container: {
    width: '100%',
    position: 'relative',
    backgroundColor: '#313131',

    [breakpoints.up('xs')]: { aspectRatio: aspectRatio['1/2'] },
    [breakpoints.up('sm')]: { aspectRatio: aspectRatio['4/3'] },
    [breakpoints.up('md')]: { aspectRatio: aspectRatio['16/9'] },
  },
}));

export default useStyles;
